import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus, faMinus, faImage, faFilePowerpoint } from "@fortawesome/free-solid-svg-icons";
// import { Button, Modal } from "react-bootstrap";
// import Modal from "admin/common/Modal";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { apiUrl, assetsUrl, fileserverUrl } from "../../config/Config";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import JSZip from "jszip";
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Pricings = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [showmodal, setshowmodal] = useState(false);
    const [editshowmodal, seteditshowmodal] = useState(false);
    const [selectedid, setselectedid] = useState(0);

    
    const [layouttype, setlayouttype] = useState("");
    const [pptfile, setpptfile] = useState("");
    const [searchtags, setsearchtags] = useState([]);
    const [image, setimage] = useState("");

    const [discountfor, setdiscountfor] = useState("All");
    const [couponcode, setcouponcode] = useState("");
    
    const [value, setvalue] = useState("");
    const [statedate, setstatedate] = useState("");
    const [enddate, setenddate] = useState("");
    const [emaillist, setemaillist] = useState([]);

    const [title, settitle] = useState("");
    const [subtitle, setsubtitle] = useState("");
    const [tagline, settagline] = useState("");
    const [type, settype] = useState("");
    const [noofslides, setnoofslides] = useState("");
    const [noofdays, setnoofdays] = useState("");
    const [mrpamount, setmrpamount] = useState("");
    const [saleamount, setsaleamount] = useState("");



    const selectedidRef = useRef(0);
    selectedidRef.current = selectedid;

    var prevtableobj = [
      {
        "title": "",
        "file": null
      }
    ];

    const [tabledataarr, settabledataarr] = useState(prevtableobj);

    const tabledataarrRef = useRef(prevtableobj);
    tabledataarrRef.current = tabledataarr;

    const [forceupdate, setforceupdate] = useState(false);



    const [rowData, setRowData] = useState([]);
    const [colDefs, setColDefs] = useState([]);
    const paginationPageSizeSelector = useMemo(() => {
        return [10, 20, 50, 100];
    }, []);

  const handleplusicon = () => {
    var prevobj = 
      {
        "title": "",
        "file": null
      };
    var prevdata = tabledataarrRef.current;
    prevdata.push(prevobj);
    settabledataarr(prevdata);
    setforceupdate(!forceupdate);
  }

  const handleminusicon = () => {
    var prevdata = tabledataarrRef.current;
    if(prevdata?.length == 1) {

    } else {
      prevdata.pop();
      settabledataarr(prevdata);
      setforceupdate(!forceupdate);
    }
   
  }

  const handleinputtablechange = (index, key, value) => {
    var prevdata = tabledataarrRef.current;
    prevdata[index][key] = value;
    settabledataarr(prevdata);
    setforceupdate(!forceupdate);
  }

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleinputchange = async (file) => {
    setpptfile(file);
    if (!file) {
      return;
    }

    // setProperties(null);
    // setError('');

    if (!file.name.endsWith('.pptx')) {
      // setError('Invalid file type. Please upload a .pptx file.');
      return;
    }

    try {
      const arrayBuffer = await file.arrayBuffer();
      const zip = await JSZip.loadAsync(arrayBuffer);
      
      const corePropsFile = zip.file('docProps/core.xml');

      if (corePropsFile) {
        const content = await corePropsFile.async('string');
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(content, 'application/xml');
        
        const getTagValue = (tagName) => {
            const elements = xmlDoc.getElementsByTagName(tagName);
            return elements.length > 0 ? elements[0].textContent : 'N/A';
        };

        const extractedProps = {
          title: getTagValue('dc:title'),
          author: getTagValue('dc:creator'),
          // ⬇️ This is the new line to get the keywords
          keywords: getTagValue('cp:keywords'), 
          lastModifiedBy: getTagValue('cp:lastModifiedBy'),
          revision: getTagValue('cp:revision'),
          createdDate: new Date(getTagValue('dcterms:created')).toLocaleString(),
          modifiedDate: new Date(getTagValue('dcterms:modified')).toLocaleString(),
        };

        console.log('extractedProps >>', extractedProps)
        var keywords = getTagValue('cp:keywords');
        var keywordsarr = keywords.split(', ');
        if(keywordsarr?.length > 0) {
          setsearchtags(keywordsarr);
        } else {
          
        }
        

        // setProperties(extractedProps);
      } else {
        // setError('Could not find core properties file (docProps/core.xml) in the presentation.');
      }
    } catch (e) {
      console.error(e);
      // setError('Failed to read or process the PPTX file.');
    }

  };

  const handleimagetablechange = async (index, key, file) => {
    var obj = {};
    await getBase64(file).then((result) => {
      obj["name"] = file.name;
      obj["image"] = result;
    });
    handleinputtablechange(index, key, obj);
    // console.log('obj >>', obj);
    // setimage(obj);
  };

  const submithandle = async () => {
    if(!title || !subtitle || !type || !mrpamount || !saleamount) {
      alert('Fill all mandatory fields!!')
      return;
    }

    // alert('Validation Passed!!');

    var data = {
      title : title,
      subtitle: subtitle,
      tagline: tagline,
      type: type,
      noofslides: type == "fixed" || type == "both" ? noofslides : 0,
      noofdays: type == "daysvalidity" || type == "both" ? noofdays : 0,
      mrpamount: mrpamount,
      saleamount: saleamount
    }

    console.log('data >>', data);

    // return;

    setshowloding(true);

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .post(apiUrl + "createpricingmodel", data, headers)
      .then((res) => {
        // console.log('res >>>', res.data)
        if (res.data.status == "success") {
          window.location.reload();
          setshowmodal(false);
          settitle("");
          setsubtitle("");
          settagline("");
          settype("");
          setnoofdays("");
          setnoofslides("");
          setmrpamount("");
          setsaleamount("");
          fetchallcourses();
          setshowloding(false);
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} })
            navigate('/admin/login');
          } else {
              alert(res.data.message);
          }
          setshowloding(false);
        }
      })
      .catch((err) => {
        setshowloding(false);
        alert(err.message);
      });

  
  setshowloding(false);
    
  };

  const edithandle = async () => {
    if(!title || !subtitle || !type || !mrpamount || !saleamount) {
      alert('Fill all mandatory fields!!')
      return;
    }

    // alert('Validation Passed!!');

    var data = {
      id: selectedidRef?.current,
      title : title,
      subtitle: subtitle,
      tagline: tagline,
      type: type,
      noofslides: type == "fixed" || type == "both" ? noofslides : 0,
      noofdays: type == "daysvalidity" || type == "both" ? noofdays : 0,
      mrpamount: mrpamount,
      saleamount: saleamount
    }

    console.log('data >>', data);

    // return;

    setshowloding(true);

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .post(apiUrl + "updatepricingmodel", data, headers)
      .then((res) => {
        // console.log('res >>>', res.data)
        if (res.data.status == "success") {
          window.location.reload();
          seteditshowmodal(false);
          settitle("");
          setsubtitle("");
          settagline("");
          settype("");
          setnoofdays("");
          setnoofslides("");
          setmrpamount("");
          setsaleamount("");
          fetchallcourses();
          setshowloding(false);
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} })
            navigate('/admin/login');
          } else {
              alert(res.data.message);
          }
          setshowloding(false);
        }
      })
      .catch((err) => {
        setshowloding(false);
        alert(err.message);
      });

      setshowloding(false);
  };

    const clickhandle = () =>  {
        // console.log('Mission Launched')
      }

      const editlocation = async(data) => {
        setselectedid(data?.id);
        console.log('editlocation data >>', data);
        settitle(data?.title);
        setsubtitle(data?.subtitle);
        settagline(data?.tag);
        settype(data?.type);
        setnoofslides(data?.noofslides ? data?.noofslides : 0);
        setnoofdays(data?.noofdays ? data?.noofdays : 0);
        setmrpamount(data?.amount);
        setsaleamount(data?.discountamount);

        setTimeout(() => {
          seteditshowmodal(true);
        }, 2000);
        
      }

      const deletecourse = async (id, title) => {
        console.log('id >>', id);
        const result = window.confirm("Are you sure you want to delete pricing model : " + title);
        if (result) {
          var data = JSON.stringify({
            id: id,
          });
          const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
          let resp = await axios
            .post(apiUrl + "deletepricingmodel", data, headers)
            .then((res) => {
              if (res.data.status == "success") {
                fetchallcourses();
              } else {
              }
            })
            .catch((err) => {
              alert(err.message);
            });
        } else {
          // User clicked Cancel or closed the dialog
          // console.log("User clicked Cancel");
        }
      };

      const defaultColDef = {
        flex: 1,
      };

      const handlesubmitquestion = () => {
        console.log('hello world!!');
      }

      const handleCheckboxChange = async(t, id, title) => {
        // console.log('t >>', t.target.checked);
        if(!t.target.checked) {
          const result = window.confirm("Are you sure you want to disable pricing model : " + title);
          if(result) {

          } else {
            return
          }
        }
        
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'id': id,
      'status': t.target.checked ? 'true': 'false'
    }
    let resp = await axios
    .post(apiUrl + "updatepricingmodelstatus", data, headers)
    .then((res) => {
      if (res.data.status == "success") {
        fetchallcourses();
        setshowloding(false);
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "userdata", payload: {} })
          navigate('/admin/login');
        } else {
          alert(res.data.message);
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
  setshowloding(false);
    console.log('data >>', data);
      }


    const fetchallcourses = async () => {
        setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .get(apiUrl + "getallpricingmodels", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallcategories >>', res.data);
              var prevdata = res.data.data;
              if(prevdata?.length > 0) {
                var columnsarr = [];
                var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'status', 'categoryid', 'description', 'facebook', 'twitter', 'linkedin', 'instagram', 'pinterest', 'slug', 'points', 'tabledata', 'pptfile', 'searchtags', 'coupon_users', 'noofslides', 'noofdays', 'subtitle'];
                var columns = Object.keys(prevdata[0]);
                // console.log('columns  >>>', columns );
                for(var i = 0; i < columns?.length;i++) {
                  if(!hidecolumns.includes(columns[i])) {
                    var obj = {};
                    obj.field = columns[i];
                    // console.log('obj >>', obj)
                    columnsarr.push(obj);
                  }
                }

                //Image
                if (columns.includes("image")) {
                  var imageobj = {
                    field: "image",
                    headerName: "Tumbnail",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <>
                          {props?.data?.image ? (
                            <Link
                              // to={assetsUrl + "images/" + props?.data?.image}
                              to={assetsUrl + props?.data?.image}
                              target="_blank"
                              style={{
                                maxWidth: 35,
                                paddingLeft: 10,
                                paddingRight: 10,
                                cursor: "pointer",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faImage}
                                className="sidebaricons"
                                style={{ color: "blue", fontSize: 18 }}
                              />
                              {/* <iframe
                                src={"https://view.officeapps.live.com/op/view.aspx?src="+assetsUrl + "ppt/" + props?.data?.pptfile}
                                width="100%"
                                height="600px"
                                frameborder="0"
                              ></iframe> */}
                            </Link>
                          ) : null}
                        </>
                      );
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  };
                  columnsarr.push(imageobj);
                }
               

                //PPT
                if (columns.includes("pptfile")) {
                  var imageobj = {
                    field: "pptfile",
                    headerName: "PPT File",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <>
                          {props?.data?.pptfile ? (
                            <Link
                              to={assetsUrl + props?.data?.pptfile}
                              target="_blank"
                              style={{
                                maxWidth: 35,
                                paddingLeft: 10,
                                paddingRight: 10,
                                cursor: "pointer",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faFilePowerpoint}
                                className="sidebaricons"
                                style={{ color: "blue", fontSize: 18 }}
                              />
                              {/* <iframe
                                src={"https://view.officeapps.live.com/op/view.aspx?src="+assetsUrl + "ppt/" + props?.data?.pptfile}
                                width="100%"
                                height="600px"
                                frameborder="0"
                              ></iframe> */}
                            </Link>
                          ) : null}
                        </>
                      );
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  };
                  columnsarr.push(imageobj);
                }

                //created_at
            //     if(columns.includes('created_at')) {
            //       var craetddatobj = 
            //   {
            //     field: "Date",
            //     headerName: "Date",
            //     cellRenderer: (props) => {
            //       // console.log('date props >>', props);
            //       return (
            //              <div>
            //               <p className="created_at_value">{moment(props?.data?.created_at).format('DD MMMM YYYY HH:mm')}</p>
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(craetddatobj);
            //     }

                 //status
             var statusobj = {
               field: "status",
               headerName: "Status",
               cellRenderer: (props) => {
                 // console.log('props >>', props?.data)
                 return (
                   <div className="d-flex">
                     <div class="form-check">
                       <input
                         onChange={(t) => {
                           handleCheckboxChange(
                             t,
                             props?.data?.id,
                             props?.data?.title
                           );
                         }}
                         type="checkbox"
                         class="form-check-input tableformcheck"
                         id="check1"
                         name="option1"
                         value="something"
                         style={{ marginTop: 12 }}
                         checked={
                           props?.data?.status == "true" ||
                           props?.data?.status == true
                             ? true
                             : false
                         }
                       />
                     </div>
                   </div>
                 );
               },
             };
             columnsarr.push(statusobj);
              
                //edit
              var editobj = 
              {
                field: "edit",
                headerName: "Edit",
                cellRenderer: (props) => {
                  
                  return (
                    <div
                          onClick={() => {
                            editlocation(props?.data);
                            // console.log('props >>', props?.data);
                          }}
                          style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                        >
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            className="sidebaricons"
                            style={{ color: "blue" }}
                          />
                        </div>
                  )
                },
                cellRendererParams: {
                  onClick: clickhandle,
                },
              }
              columnsarr.push(editobj);

                //delete
                // var deleteobj = 
                // {
                //   field: "delete",
                //   headerName: "Delete",
                //   cellRenderer: (props) => {
                    
                //     return (
                //       <div
                //             onClick={() => {
                //               deletecourse(props?.data?.id, props?.data?.title);
                //               // console.log('props >>', props?.data);
                //             }}
                //             style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                //           >
                //             <FontAwesomeIcon
                //               icon={faTrash}
                //               className="sidebaricons"
                //               style={{ color: "red" }}
                //             />
                //           </div>
                //     )
                //   },
                //   cellRendererParams: {
                //     onClick: clickhandle,
                //   },
                // }
                // columnsarr.push(deleteobj);
                setColDefs(columnsarr);
                setRowData(prevdata);
              } else {
                setColDefs([]);
                setRowData([]);
              }
              
              // setcoursesdata(res.data.data);
            } else {
              // alert(res.data.message);
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
      };

    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              //   fetchdata();
              fetchallcourses();
            } else {
              navigate("/admin/login");
            }
          }, []);

          const today = new Date().toISOString().split("T")[0];
    return (
      <div className="adminmainpagelayout">
        <div className="productstogglebar mt-2">
          <div
            className="filterdiv couponfilterdiv"
            onClick={() => {
              setimage("");
              setpptfile("");
              setshowmodal(true);
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="iconstyles"
              style={{ color: "#64748B" }}
            />
            <p>Add New</p>
          </div>
        </div>

        <div
          className={"ag-theme-quartz"}
          style={{ width: "100%", height: 500, marginTop: 15 }}
        >
          <AgGridReact
            // modules={AllModules}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            // onGridReady={onGridReady}
          />
        </div>

        {/*Add modal */}
        <Modal
          show={showmodal}
          onHide={() => setshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>
              Configure New Subscription Model
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Title *</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Name"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Sub Title *</label>
                <input
                  value={subtitle}
                  onChange={(t) => {
                    setsubtitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Sub-title"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Tagline (Optional)</label>
                <input
                  value={tagline}
                  onChange={(t) => {
                    settagline(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="For e.g. Most Popular"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Model Type *</label>
                <select
                  className="form-control"
                  value={type}
                  onChange={(t) => {
                    settype(t.target.value);
                  }}
                >
                  <option value={""} selected disabled>
                    Select
                  </option>
                  <option value={"fixed"}>Fixed</option>
                  <option value={"daysvalidity"}>Days Validity</option>
                  <option value={"both"}>Both</option>
                </select>
              </div>

              {
               type == "fixed" || type == "both" ?
               <div className="mt-3">
               <label className="addproduct-label">No. of Slides</label>
               <input
                 value={noofslides}
                 onChange={(t) => {
                   const onlyNumbers = t.target.value.replace(/[^0-9]/g, '');
                   setnoofslides(onlyNumbers);
                 }}
                 type="text"
                 className="form-control addproductinput"
                 placeholder=""
               />
             </div> : null
              }

{
               type == "daysvalidity" || type == "both" ?
               <div className="mt-3">
                <label className="addproduct-label">No. of Days</label>
                <input
                  value={noofdays}
                  onChange={(t) => {
                    const onlyNumbers = t.target.value.replace(/[^0-9]/g, '');
                    setnoofdays(onlyNumbers);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder=""
                />
              </div> : null
              }


              <div className="row mt-3">
                <div className="col-12 col-sm-6">
                  <label className="addproduct-label">Amount *</label>
                  <input
                    value={mrpamount}
                    onChange={(t) => {
                        const onlyNumbers = t.target.value.replace(/[^0-9]/g, '');
                        setmrpamount(onlyNumbers);
                      
                    }}
                    maxLength={4}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="form-control addproductinput"
                    placeholder="Amount in USD"
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label className="addproduct-label">Discount Amount *</label>
                  <input
                    value={saleamount}
                    onChange={(t) => {
                        const onlyNumbers = t.target.value.replace(/[^0-9]/g, '');
                        setsaleamount(onlyNumbers);
                      
                    }}
                    maxLength={4}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="form-control addproductinput"
                    placeholder="Amount in USD"
                  />
                </div>
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    if(showloding) {
                      
                    } else {
                      submithandle();
                    }
                    
                  }}
                >
                  {
                    showloding ?
                    <p><Spinner color="#fff" size={15} className="spinnerCenter" /></p>:
                    <p>Submit</p>
                  }
                  
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/*Edit modal */}
        <Modal
          show={editshowmodal}
          onHide={() => seteditshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Edit Subscription Model</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Title *</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Name"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Sub Title *</label>
                <input
                  value={subtitle}
                  onChange={(t) => {
                    setsubtitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Sub-title"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Tagline (Optional)</label>
                <input
                  value={tagline}
                  onChange={(t) => {
                    settagline(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="For e.g. Most Popular"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Model Type *</label>
                <select
                  className="form-control"
                  value={type}
                  onChange={(t) => {
                    settype(t.target.value);
                  }}
                >
                  <option value={""} selected disabled>
                    Select
                  </option>
                  <option value={"fixed"}>Fixed</option>
                  <option value={"daysvalidity"}>Days Validity</option>
                  <option value={"both"}>Both</option>
                </select>
              </div>

              {
               type == "fixed" || type == "both" ?
               <div className="mt-3">
               <label className="addproduct-label">No. of Slides</label>
               <input
                 value={noofslides}
                 onChange={(t) => {
                   const onlyNumbers = t.target.value.replace(/[^0-9]/g, '');
                   setnoofslides(onlyNumbers);
                 }}
                 type="text"
                 className="form-control addproductinput"
                 placeholder=""
               />
             </div> : null
              }

{
               type == "daysvalidity" || type == "both" ?
               <div className="mt-3">
                <label className="addproduct-label">No. of Days</label>
                <input
                  value={noofdays}
                  onChange={(t) => {
                    const onlyNumbers = t.target.value.replace(/[^0-9]/g, '');
                    setnoofdays(onlyNumbers);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder=""
                />
              </div> : null
              }

             
              <div className="row mt-3">
                <div className="col-12 col-sm-6">
                  <label className="addproduct-label">Amount *</label>
                  <input
                    value={mrpamount}
                    onChange={(t) => {
                        const onlyNumbers = t.target.value.replace(/[^0-9]/g, '');
                        setmrpamount(onlyNumbers);
                      
                    }}
                    maxLength={4}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="form-control addproductinput"
                    placeholder="Amount in USD"
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label className="addproduct-label">Discount Amount *</label>
                  <input
                    value={saleamount}
                    onChange={(t) => {
                        const onlyNumbers = t.target.value.replace(/[^0-9]/g, '');
                        setsaleamount(onlyNumbers);
                      
                    }}
                    maxLength={4}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="form-control addproductinput"
                    placeholder="Amount in USD"
                  />
                </div>
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    if(showloding) {
                      
                    } else {
                      edithandle();
                    }
                    
                  }}
                >
                  {
                    showloding ?
                    <p><Spinner color="#fff" size={15} className="spinnerCenter" /></p>:
                    <p>Update</p>
                  }
                  
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
}

export default Pricings